/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo, useRef, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { Form } from 'formik-antd';
import { useDispatch } from 'react-redux';
import { Box, Button } from 'atoms';
import { Debug } from './Debug';
import { ACL, EditModeBtn, ImageView } from 'components/common';
// import { useQuery } from 'hooks';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import { DATE_FORMAT, pdfimgfiletypetoShow, pdfimgformates } from 'utils';
import { CancelButton } from 'utils/commonStyled';
import { updateVendorSection } from 'store/vendorSlice';

export default function VendorVRFForm({
	isEditMode = false,
	formData = {},
	otherFormsData,
	activeTab,
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// const [query] = useQuery();
	const [editMode, setEditMode] = useState(false);
	const filesList = [];
	console.log(activeTab);
	console.log(formData);
	console.log(otherFormsData);

	const FormSchema = useMemo(
		() =>
			Yup.object({
				vrf_signed_copy: Yup.array().required(),
			}),
		[]
	);

	const getMonentDate = (date) => {
		console.log(date);
		return date === '' ? undefined : moment(date);
	};

	const initialValues = useMemo(
		() => ({
			vendor_type: formData?.vendor_type || undefined,
			acc_number: formData?.banking_info?.acc_number || undefined,
			ifsc_code: formData?.banking_info?.ifsc_code || undefined,
			bank_name: formData?.banking_info?.bank_name || undefined,
			bank_city: formData?.banking_info?.bank_city || undefined,
			bank_doc: formData?.banking_info?.bank_doc || undefined,
			bank_branch: formData?.banking_info?.bank_branch || undefined,
			pan_number: formData?.document_info?.pan_number || undefined,
			gst_reg_type: formData?.document_info?.gst_reg_type || undefined,
			aadhar_number: formData?.document_info?.aadhar_number || undefined,
			gst_number: formData?.document_info?.gst_number || undefined,
			related_party: formData?.other_info?.related_party || false,
			black_listed: formData?.other_info?.black_listed || false,
			holding_payment: formData?.other_info?.holding_payment || false,
			logistic_vendor: formData?.other_info?.logistic_vendor || false,
			discount_early_payment: formData?.other_info?.discount_early_payment || false,
			tds_applicable: formData?.other_info?.tds_applicable || false,
			document_currency: formData?.other_info?.document_currency || undefined,
			credit_period: formData?.other_info?.credit_period || undefined,
			payment_tnc: formData?.payment_tnc || undefined,
			cert_no: formData?.tax_info?.cert_no || undefined,
			tax_cert_start_date:
				getMonentDate(formData?.tax_info?.tax_cert_start_date) || undefined,
			tax_cert_valid_till:
				getMonentDate(formData?.tax_info?.tax_cert_valid_till) || undefined,
			is_vendor_msme: formData?.other_info?.is_vendor_msme || false,
			msme_reg_no: formData?.other_info?.msme_reg_no || undefined,
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[formData]
	);

	const getValidIMages = (bank_doc) => {
		console.log('bank_doc ', bank_doc);
		if (bank_doc) {
			return bank_doc;
		}
		if (!isEmpty(filesList)) {
			return filesList;
		}
		return undefined;
	};
	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		let payload = {};
		if (formData?.vendor_type === 'regular') {
			payload = {
				update_type: 'vendor',
				id: formData?.id,
				vendor_type: 'regular',
				vendor_info: formData?.vendor_info,
				banking_info: {
					acc_number: values?.acc_number,
					bank_branch: values?.bank_branch,
					bank_city: values?.bank_city,
					bank_name: values?.bank_name,
					ifsc_code: values?.ifsc_code.toUpperCase(),
					bank_doc: getValidIMages(formData?.banking_info?.bank_doc),
				},
				document_info: {
					pan_number: values?.pan_number.toUpperCase(),
					gst_reg_type: values?.gst_reg_type,
					aadhar_number: values?.aadhar_number,
					gst_number: values?.gst_number,
					pan_doc: !isEmpty(panFilesList)
						? panFilesList
						: formData?.document_info?.pan_doc,
					aadhar_doc: !isEmpty(aadharFilesList)
						? aadharFilesList
						: formData?.document_info?.aadhar_doc,
					gst_doc: !isEmpty(gstFilesList)
						? gstFilesList
						: formData?.document_info?.gst_doc,
				},
				tax_info: {
					cert_no: values?.cert_no,
					tax_cert_start_date: values?.cert_no
						? moment(values?.tax_cert_start_date).format(DATE_FORMAT)
						: undefined,
					tax_cert_valid_till: values?.cert_no
						? moment(values?.tax_cert_valid_till).format(DATE_FORMAT)
						: undefined,
				},
				other_info: {
					related_party: values?.related_party,
					black_listed: values?.black_listed,
					holding_payment: values?.holding_payment,
					logistic_vendor: values?.logistic_vendor,
					discount_early_payment: values?.discount_early_payment,
					tds_applicable: values?.tds_applicable,
					document_currency: values?.document_currency,
					credit_period: Number(values?.credit_period),
					payment_tnc: values?.payment_tnc,
					is_vendor_msme: values?.is_vendor_msme,
					msme_reg_no: values?.msme_reg_no,
				},
				vrf_signed_copy: !isEmpty(vrfFilesList) ? vrfFilesList : formData?.vrf_signed_copy,
			};
		}
		console.log(payload);
		dispatch(
			updateVendorSection({
				req_data: payload,
				setErrors,
			})
		)
			.then((res) => {
				console.log(res);
				navigate('/vendor-list');
				setSubmitting(false);
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	const ref = useRef(null);

	const { panFilesList, aadharFilesList, gstFilesList } = [];
	const [vrfFilesList, setVrfFilesList] = useState([]);

	function handleFileUpload(files, key, setFieldValue) {
		console.log('key ', key);
		setFieldValue('vrf_signed_copy', files);
		setVrfFilesList(files);
	}
	function handleEdit() {
		setEditMode(!editMode);
	}

	return (
		<Formik
			innerRef={ref}
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{({ values, setFieldValue, errors }) => {
				console.log('values ', values);
				console.log({ errors });
				console.log(formData?.vendor_type);
				console.log({ setFieldValue });

				return (
					<Box>
						<ACL action="update" module="vendor">
							{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
						</ACL>
						<Form className={editMode === false ? 'disabled-div' : ''}>
							{formData?.vendor_type === 'regular' && (
								<Box>
									<Box border="1px solid #ccc" marginTop="16px" padding="34px">
										<FilesUploadS3
											entity="vendor"
											key="vrf_signed_copy"
											setFunc={setFieldValue}
											successCallBack={handleFileUpload}
											name="VRF document"
											size={5120000}
											fileformates={pdfimgformates}
											filetypetoShow={pdfimgfiletypetoShow}
										/>
										<Box>
											{errors?.vrf_signed_copy && (
												<Box backgroundColor="#fff" color="red">
													VRF Document is required
												</Box>
											)}
										</Box>
										<Box
											backgroundColor="#fff"
											textAlign="right"
											padding="1.5rem"
										>
											{}
										</Box>
										{isEditMode && (
											<ImageView
												className="allowDownload"
												entity="vendor"
												files={formData?.vrf_signed_copy}
												name="PAN Document"
											/>
										)}
									</Box>
								</Box>
							)}
							<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
								<CancelButton
									onClick={() => navigate('/vendor-list')}
									type="button"
								>
									Cancel
								</CancelButton>
								<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
									{isEditMode ? 'Update' : 'Submit'}
								</Button>
							</Box>
							<Debug />
						</Form>
					</Box>
				);
			}}
		</Formik>
	);
}

VendorVRFForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
	activeTab: PropTypes.any,
};
